import React, { useState } from "react";
import { TimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { Settings, DateTime } from "luxon";
import { Controller, useFormContext } from "react-hook-form";
import type { UseControllerProps } from "react-hook-form/dist/types/controller";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface FormTimePickerProps extends UseControllerProps<any> {
  label: string;
}

export function FormTimePicker(props: FormTimePickerProps) {
  const { setValue, control, trigger } = useFormContext();

  const [time, setTime] = useState<DateTime | null>(props.defaultValue ?? null);

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={Settings.defaultLocale}>
      <Controller
        name={props.name}
        rules={props.rules}
        shouldUnregister={props.shouldUnregister}
        defaultValue={props.defaultValue}
        control={control}
        render={({ field: { ref, ...rest }, fieldState }) => {
          let helperText = null;

          if (time && time.isValid) {
            const localTime = time.toLocal();
            helperText = `${localTime.toLocaleString(DateTime.TIME_SIMPLE)} (${localTime.zoneName})`;
          }

          if (fieldState.invalid) {
            helperText = fieldState.error?.message;
          }

          return (
            <TimePicker
              {...rest}
              onChange={(value) => {
                setTime(value);
                setValue(props.name, value);
                trigger(props.name);
              }}
              value={time}
              label={`${props.label} (UTC)`}
              slotProps={{
                textField: {
                  variant: "outlined",
                  required: !!props.rules?.required,
                  error: fieldState.invalid,
                  helperText,
                  fullWidth: true,
                },
              }}
            />
          );
        }}
      />
    </LocalizationProvider>
  );
}
